module.exports = __webpack_public_path__ + "media/flags/bv-fef2fc11.svg";